// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"29522364","124":"2a543fd7","168":"a4ea8625","218":"d914250d","240":"08b2d953","448":"96d04df1","453":"18f75a51","593":"bbb17f0a","654":"e7699950","697":"05ccfd04","759":"1de5de95","869":"2fe30eb4","944":"8fc1709c"}[chunkId] + ".chunk.js";
};